import React from "react";
import MasterData from "view/settings/masterdata/MasterData";
const LeadsData = () => {
   
    const sections = [
        { label: "Status", value: "Status", items: [] },
        { label: "Type", value: "Type", items: [] },
        { label: "Current Stage", value: "CurrentStage", items: [] },
        { label: "Proposal Status", value: "ProposalStatus", items: [] },
    ];
   

    return (
        <>
            <MasterData pageTitle="Leads" sections={sections} />
        </>

    );
};

export default LeadsData;